import { ContentfulItems } from "@/types/Contentful.model";

export enum BUTTON_TYPE_CLASS {
  PRIMARY = "primary-btn rounded-btn p-btn text-center text-p uppercase outline-2 outline-offset-0 cursor-pointer",
  SECONDARY = "secondary-btn rounded-btn bg-transparent p-btn text-center text-p uppercase outline-2 outline-offset-0 mx-sm cursor-pointer",
}

export enum BUTTON_DISABLED_CLASS {
  PRIMARY = "primary-btn--disabled bg-monochrome-grey text-monochrome-darkGrey outline-monochrome-grey",
  SECONDARY = "secondary-btn--disabled text-monochrome-darkGrey",
}

export enum BUTTON_SUBTYPE_CLASS {
  PRIMARY_BLACK = "primary-btn--black bg-core-black text-core-white outline-core-black hover:bg-transparent hover:text-core-black focus:bg-transparent focus:text-core-black",
  PRIMARY_BLACK_OUTLINE = "primary-btn--blackOutline bg-transparent text-core-black outline-core-black hover:bg-core-black hover:text-core-white focus:bg-core-black focus:text-core-white",
  PRIMARY_WHITE = "primary-btn--white bg-core-white text-core-black outline-core-white hover:bg-core-black hover:text-core-white focus:bg-core-black focus:text-core-white",
  PRIMARY_WHITE_OUTLINE = "primary-btn--whiteOutline bg-transparent text-core-white outline-core-white hover:bg-core-white hover:text-core-black focus:bg-core-white focus:text-core-black",
  SECONDARY_BLACK = "secondary-btn--black bg-transparent text-core-black outline-core-black hover:bg-core-black hover:text-core-white focus:bg-core-black focus:text-core-white",
  SECONDARY_WHITE = "secondary-btn--white text-core-white hover:bg-core-white hover:text-core-black focus:bg-core-white focus:text-core-black",
}

export interface Button extends ContentfulItems {
  text: string;
  url?: string;
}

export interface ButtonPropsModel
  extends Omit<React.HTMLAttributes<HTMLAnchorElement>, "content"> {
  primary: boolean;
  type?: BUTTON_SUBTYPE_CLASS;
  actionType?: HTMLButtonElement["type"];
  disabled?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
  content: Button;
  onClick?: () => void;
}
